import { Component } from '@angular/core';
import {ModalCerrarSesionComponent} from "../modal-cerrar-sesion/modal-cerrar-sesion.component";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {UserService} from "../../services/user.service";
import {UsuarioModel} from "../../../models/usuario.model";
import {versions} from "../../../environments/version";

@Component({
  selector: 'app-modal-perfil',
  standalone: true,
  imports: [],
  templateUrl: './modal-perfil.component.html',
  styleUrl: './modal-perfil.component.scss'
})
export class ModalPerfilComponent {

  usuario: UsuarioModel;
  gitV: string;
  gitH: string;
  groupsTexto: string;

  constructor(private modalService: BsModalService, private bsModalRef: BsModalRef, private userService: UserService) {
    this.usuario = this.userService.getUsuario();
    this.groupsTexto = this.userService.getGroupsTexto().toUpperCase();
    this.gitV = `V ${versions.version}`;
    this.gitH = `Rev: ${versions.revision}`;
  }

  close() {
    this.bsModalRef.hide();
  }

  showModalCerrarSesion() {
    this.modalService.show(ModalCerrarSesionComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs'
    });
  }

}
